import {
  getIdentifiedNeedsHTML,
} from 'src/pages/facesheet/_id/eligibility/utils';
import {
  useScreening,
} from 'src/pages/facesheet/_id/eligibility/hooks/eligibilityApi';
import { get } from 'lodash';

const ALL_NEEDS_AVAILABLE = [
  'transportation',
  'food',
  'housing',
  'utilities',
  'unemployment',
  'education',
];

export const renderIdentifiedNeeds = (
  scrn942ScreeningsResultsUpdatesEnabled,
  surveyRef,
  relatedScreening,
  SURVEY_PAGE_NUMBER = 0,
) => {
  if (!relatedScreening || !surveyRef?.current) { return; }

  const identifiedNeeds = get(relatedScreening, 'identified_needs', null);
  const needs = identifiedNeeds ? Object.keys(identifiedNeeds) : [];
  const filteredNeeds = needs.filter((n) => ALL_NEEDS_AVAILABLE.includes(n));
  const surveyPage = surveyRef.current.pages[SURVEY_PAGE_NUMBER];
  const qIdentifiedNeeds = surveyPage.getQuestionByName('qIdentifiedNeedsHtml');
  const htmlElement = document.getElementById(qIdentifiedNeeds.id);

  if (htmlElement) {
    htmlElement.innerHTML = getIdentifiedNeedsHTML(scrn942ScreeningsResultsUpdatesEnabled, filteredNeeds);
  }
};

export const useRelatedScreening = (relatedScreenId) => {
  const { data: relatedScreening } = useScreening(relatedScreenId, { enabled: Boolean(relatedScreenId) });
  const identifiedNeeds = get(relatedScreening, 'identified_needs', null);
  const needs = identifiedNeeds ? Object.keys(identifiedNeeds) : [];

  return {
    relatedScreening,
    needs,
  };
};
